export enum DocumentContentType {
  'msword'= 'doc',
  'vnd.openxmlformats-officedocument.wordprocessingml.document' = 'docx',
  'vnd.openxmlformats-officedocument.wordprocessingml.template' = 'dotx',
  'vnd.ms-excel' = 'xls',
  'vnd.openxmlformats-officedocument.spreadsheetml.sheet' = 'xlsx'
}
